import React from "react";

export default function Footer() {
  return (
    <footer>© {new Date().getFullYear()} BEELUXE · PURE GOLDEN HONEY</footer>
  );
}
